<template>
  <v-row justify-center align-center column>
    <!--RECORDER-->
    <!--TODO: Align it with camera buttons. -->
    <v-col xs="12" offset-xs2 offset-sm1>
      <v-row row>
        <v-col>
          <!--
            <v-btn
              color="#747474"
              flat
              icon
              @click="stopRecording"
            >
              <v-icon>stop</v-icon>
            </v-btn>
          -->
          <v-btn
            v-if="!recState"
            color="#05CBCD"
            fab
            outlined
            :class="{
              'ml-3': $vuetify.display.xsOnly,
              'ml-2': $vuetify.display.smOnly,
              'mr-3': $vuetify.display.mdAndUp,
            }"
            @click="startRecording"
          >
            <v-icon color="#747474" x-large> mic </v-icon>
          </v-btn>
          <v-btn
            v-if="recState"
            color="#05CBCD"
            fab
            outlined
            @click="stopRecording"
          >
            <v-icon color="#747474" x-large> stop </v-icon>
          </v-btn>

          <v-btn color="#747474" variant="outlined" icon @click="deleteRecording">
            <v-icon>delete_forever</v-icon>
          </v-btn>
        </v-col>
      </v-row>
    </v-col>
    <!--PLAYER-->
    <v-col xs="12">
      <audio v-if="dataUrl" controls>
        <source :src="dataUrl" type="audio/ogg" />
      </audio>
    </v-col>
  </v-row>
</template>

<script>
let audioStream;
let mediaRecorder;

function initMediaDevices() {
  return new Promise((resolve, reject) => {
    navigator.mediaDevices
      .getUserMedia({ audio: true })
      .then((stream) => {
        resolve(stream);
      })
      .catch((error) => {
        reject(error);
      });
  });
}
export default {
  data: () => ({
    blob: null,
    dataUrl: null,
    recState: false,
  }),
  mounted() {
    this.startAudioDevice();
  },
  beforeUnmount() {
    this.deleteRecording();
    this.stopAudioDevice();
  },
  methods: {
    startAudioDevice() {
      initMediaDevices().then((stream) => {
        let chunks = [];
        audioStream = stream;
        mediaRecorder = new MediaRecorder(stream);
        mediaRecorder.ondataavailable = (event) => {
          chunks.push(event.data);
        };
        mediaRecorder.onstop = (event) => {
          this.blob = new Blob(chunks, {
            type: "audio/ogg; codecs=opus",
          });
          chunks = [];
          this.dataUrl = window.URL.createObjectURL(this.blob);
          this.$emit("record", { dataUrl: this.dataUrl, blob: this.blob });
        };
      });
    },
    stopAudioDevice() {
      if (audioStream) {
        const tracks = audioStream.getTracks();
        tracks.forEach((track) => {
          track.stop();
        });
      }
    },
    startRecording() {
      if (mediaRecorder.state === "paused") {
        mediaRecorder.resume();
      } else {
        mediaRecorder.start();
      }
      this.recState = true;
    },
    stopRecording() {
      if (mediaRecorder.state !== "inactive") {
        mediaRecorder.stop();
        this.recState = false;
      }
    },
    pauseRecording() {
      mediaRecorder.pause();
      this.recState = false;
    },
    deleteRecording() {
      this.blob = null;
      this.dataUrl = null;
      this.$emit("delete");
    },
  },
};
</script>
